export const GET_STARTED_BANNER_HIDDEN = '_GET_STARTED_BANNER_HIDDEN_';
